import React from 'react';
import { Children } from 'utils/types/react';

interface OutsideClickHandlerProps {
  onClick: Function;
  children: Children;
}

function OutsideClickHandler(props: OutsideClickHandlerProps) {
  const node = React.useRef<any>(null);

  React.useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  function handleClick(event) {
    let isDescendantOfRoot =
      node.current && node.current?.contains(event.target);

    if (!isDescendantOfRoot) {
      props.onClick(event);
    }
  }

  return <span ref={node}>{props.children}</span>;
}

export default OutsideClickHandler;
